module.exports = __webpack_public_path__ + "fonts/Latinka-ExtraBoldItalic.ca992c41.ttf";